<script>
  import { format } from 'svelte-i18n';

  export let row = {};
</script>

<div class="tags">
  {#if row.tags.length}
    {#each row.tags as tag}
      <div class="tag">{tag.label}</div>
    {/each}
  {:else}
    <div class="empty">{$format('label.NO_TAGS')}</div>
  {/if}
</div>

<style lang="scss">
  .tags {
    display: flex;
    gap: 8px;
    flex-wrap: wrap;
  }

  .empty,
  .tag {
    align-items: center;
    background-color: var(--color-blue-300);
    border-radius: var(--border-radius-base);
    color: var(--color-white);
    display: inline-flex;
    font-size: var(--font-size-small);
    padding: var(--padding-small) var(--padding-base);
    white-space: nowrap;
  }

  .empty {
    background-color: var(--color-gray-200);
    color: var(--color-gray-600);
  }
</style>
